import _ from 'lodash';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// const initialOperation = 'Ocean Import';
const initialOperation = 'Home';

export interface OperationState {
  operation: string,
  sideMenu: string, // Name of the operation which displays side menu
};

const initialState: OperationState = {
  operation: initialOperation,
  sideMenu: '',
};

/**
 * Slice for controlling Operation
 * 
 */
const operationSlice = createSlice({
  name: 'operation',
  initialState,
  reducers: {
    clearOperation: () => _.cloneDeep(initialState),
    changeOperation: (state, action: PayloadAction<string>) => {
      state.operation = action.payload;
      state.sideMenu = action.payload;
    },
    changeSideMenu: (state, action: PayloadAction<string>) => {
      state.sideMenu = action.payload;
    },
  }
});

export default operationSlice.reducer;

export const { clearOperation, changeOperation, changeSideMenu } = operationSlice.actions;
